import axios from 'axios';
import { GRID_SITE_STATUS_ENDPOINT } from '../constants/endpoint';

export default async (contactId, refresh) => {
  let endpoint = `${GRID_SITE_STATUS_ENDPOINT}/${contactId}`;
  if (refresh) {
    endpoint = `${GRID_SITE_STATUS_ENDPOINT}/${contactId}?refresh=true`;
  }

  const response = await axios.get(endpoint);
  return response;
};
